import script from "./Title-action.vue?vue&type=script&setup=true&lang=js"
export * from "./Title-action.vue?vue&type=script&setup=true&lang=js"

import "./Title-action.vue?vue&type=style&index=0&id=f400b4d2&lang=scss"

const __exports__ = script;

export default __exports__